import { cx } from '@/lib/cx';

/** Placeholder block for loading states. Decorative — hidden from the a11y tree. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cx(
        'block animate-pulse rounded-sm bg-surface-sunken motion-reduce:animate-none',
        className,
      )}
    />
  );
}
